import axios from "axios";

const ACCOUNT_URL = process.env.REACT_APP_API_USER_URL;
const USER_URL = process.env.REACT_APP_API_USER_ACCOUNT_URL;
const getToken = (token) => ({Authorization: `Bearer ${token}`});

export const checkToken = (token) => {
    return axios.post(`${ACCOUNT_URL}/token`, null, {
        headers: getToken(token),
        timeout: 1000,
    });
}

// 로그인
export const login = (data) => {
    return axios.post(`${USER_URL}/login`, data);
};

// 구글로그인
export const googleLogin = async (data) => {
    return axios.post(`${USER_URL}/login/google`, data);
}

// 로그인 시 클라이언트 IP 가져오기
export const ipCheck = () => {
    return axios.get('https://api64.ipify.org?format=json');
};

// 기업 중복 확인
export const companyCheck = (params) => {
    return axios.get(`${USER_URL}/check`, {
        params,
    });
};

// 회원가입
export const signup = (data) => {
    return axios.post(`${USER_URL}/join`, data);
};

// 이메일 인증
export const confirmEmail = (cert) => {
    const formdata = new FormData();
    formdata.append("cert", cert);
    return axios.post(`${USER_URL}/confirm`, formdata);
};

// 이메일 재인증
export const reconfirmEmail = (data) => {
    return axios.post(`${USER_URL}/email/resend`, data);
};

// 비밀번호 찾기
export const findPassword = (data) => {
    return axios.post(`${USER_URL}/find/passwd`, data)
}

// 비밀번호 찾기 인증 및 비밀번호변경
export const findConfirm = (data) => {
    const formData = new FormData();
    formData.append("cert", data.cert);
    formData.append("password", data.password);
    return axios.put(`${USER_URL}/find/confirm`, formData)
}
